import { render, staticRenderFns } from "./accordion-checkout-summary.vue?vue&type=template&id=1154d0b8&"
import script from "./accordion-checkout-summary.vue?vue&type=script&lang=js&"
export * from "./accordion-checkout-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports